module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foo",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("HOME")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-917b4af8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = 500
// module chunks = 1